import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Helpers from "@/mixins/helpers";
import Api from "@/mixins/api";
import Recipe from "@/mixins/recipe";
import Icon from "@/components/ui/Icon";
import GSignInButton from "vue-google-signin-button";
import VueAnalytics from "vue-analytics";
import humanizeDuration from "humanize-duration";
import { MdField, MdButton, MdSnackbar } from "vue-material/dist/components";
import Fragment from "vue-fragment";

import "vue-material/dist/vue-material.min.css";
import "./scss/plugins/_vue-material.scss";

import "@/assets/icons";
import SvgIcon from "@/components/ui/SvgIcon";
import moment from "moment";
import "moment/locale/fr";
Vue.use(require("vue-moment"), {
  moment,
});
Vue.use(MdField);
Vue.use(MdButton);
Vue.use(MdSnackbar);

// Configuration VueAnalytics
const analytics = process.env.NODE_ENV === "production" ? "UA-163926531-1" : "";
Vue.use(VueAnalytics, {
  id: analytics,
  router,
});

Vue.use(GSignInButton);

Vue.use(require("vue-moment"));

Vue.component("svgicon", SvgIcon);

import mq from "./store/mq";
Vue.prototype.$mq = mq.state;

Vue.mixin(Helpers);
Vue.mixin(Api);
Vue.mixin(Recipe);

Vue.use(Fragment.Plugin);
Vue.prototype.$duration = (duration) => {
  return humanizeDuration(duration * 60 * 1000, {
    serialComma: false,
    spacer: "",
    language: "custom",
    languages: {
      custom: {
        y: () => "y",
        mo: () => "mo",
        w: () => "semaine",
        d: () => "jours",
        h: () => "h",
        m: () => "min.",
        s: () => "s",
        ms: () => "ms",
      },
    },
  }).replace(",", "");
};

Vue.component("Icon", Icon);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
